const tooltip = "_tooltip_1nqnq_8";
const invisible = "_invisible_1nqnq_21";
const caption = "_caption_1nqnq_28";
const arrow = "_arrow_1nqnq_33";
const styles = {
  tooltip,
  invisible,
  caption,
  arrow
};
export {
  arrow,
  caption,
  styles as default,
  invisible,
  tooltip
};
//# sourceMappingURL=Tooltip.module.css.js.map
